import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useSubmitStockLevels } from '@/services/catalogue/useCustomerCatalogueService';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router';

const BeginFilfillmentModal: FunctionComponent<ModalProps> = props => {
  const navigate = useNavigate();
  const submitStockLevels = useSubmitStockLevels();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const routePrefix = useCustomerRoutePrefix();

  const onSubmit = async () => {
    setLoading(true);

    try {
      await submitStockLevels();
      navigate(`${routePrefix}/advanced/stockComplete`);
    } catch (error) {
      setErrorMessage('Unable to submit stock levels.');
    }

    setLoading(false);
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Card className="w-full p-8 space-y-2">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Begin Fulfillment</h1>
        </Modal.Controls>
        <div className="pt-2">Are you sure you want to begin fulfillment?</div>
        {errorMessage && <div className="text-red-500">{errorMessage}</div>}
        <div className="mt-2 flex gap-2 justify-between">
          <Button onClick={props.close}>Cancel</Button>
          <Button type="button" loading={loading} variant={ButtonVariant.Primary} onClick={onSubmit}>
            Confirm
          </Button>
        </div>
      </Card>
    </Modal>
  );
};

export default BeginFilfillmentModal;
